<template>
  <div></div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: 'PicaServiceRedirect',
  computed: {
    ...mapGetters('event', ['isDraft', 'isEdge', 'allowsOverview']),
    ...mapGetters('eventGallery', ['galleries']),
    ...mapGetters('eventWizard', ['isStepVisible']),
    ...mapGetters('login', ['hasPerms']),
    ...mapGetters('features', ['isPrintersEnabled']),
  },
  async mounted() {
    // Aspetta che EventManager finisca il loading
    let attempts = 0
    while (this.$parent?.loading && attempts < 100) {
      await new Promise(resolve => setTimeout(resolve, 50))
      attempts++
    }

    const picaServiceId = parseInt(this.$route.params.picaServiceId)

    // Priority 1: If event is draft, go to event profile
    if (this.isDraft) {
      await this.$router.replace({
        name: 'eventWizard.date_and_name',
        params: {picaServiceId}
      })
      return
    }

    // Priority 2: Edge Prints List
    if (this.isPrintersEnabled && this.hasPerms(['event_wizard.see_printer'])) {
      await this.$router.replace({
        name: 'edgePrintOrderList',
        params: {picaServiceId}
      })
      return
    }

    // Priority 3: Edge Orders List
    if (this.isEdge && this.hasPerms(['event_wizard.see_orders'])) {
      await this.$router.replace({
        name: 'edgeOrderList',
        params: {picaServiceId}
      })
      return
    }

    // Priority 4: Overview (if allowed and has permission)
    if (this.allowsOverview && this.hasPerms(['event_wizard.see_overview'])) {
      await this.$router.replace({
        name: 'eventWizard.overview',
        params: {picaServiceId}
      })
      return
    }

    // Priority 5: Event profile (if step is visible)
    if (this.isStepVisible('date_and_name')) {
      await this.$router.replace({
        name: 'eventWizard.date_and_name',
        params: {picaServiceId}
      })
      return
    }

    // Priority 6: First gallery (if exists)
    if (this.galleries && this.galleries.length > 0) {
      const galleryId = this.galleries[0].id
      await this.$router.replace({
        name: 'eventWizard.gallery.browse_photo',
        params: {picaServiceId, galleryId}
      })
      return
    }

    // Final fallback: Event profile
    await this.$router.replace({
      name: 'eventWizard.date_and_name',
      params: {picaServiceId}
    })
  }
}
</script>
